import { defineComponent } from 'vue';
import axios, { AxiosResponse } from 'axios';
import DCApp from "./../Shared/App.vue";
import * as Vue from 'vue';
import "lightbox2";
import { newsElem, NewsViewApiModel } from './../news/newsmodule';
import * as fitvids from "fitvids";
import Comments from "./../Shared/comments.vue";
import { createPinia } from 'pinia';
//import * as sanitizeHtml  from 'sanitize-html';


let gid: number;
gid = 0;
let gnumcomments: number;
gnumcomments = 0;
let gnumcommentsinitial: number;
gnumcommentsinitial = 0;
let gnumtotalnews: number;
gnumtotalnews = 0;
let glancurrent: string = "fr";
let gactucats: string = "";

const mixin = defineComponent({
    components: { Comments },
    data() {
        return {
            last_page: 1,
            last_pagenews:2,
            idactu: 0,
            numcomments: 0,
            numcommentsinitial: 0,
            dcloadingnews: false,
            postnews: [] as newsElem[],
            numnews: 0,
            lancurrent: "fr",
            actucats: ""
        };
    },
    methods: {
        ShowComments(event: any) {
            (this.$refs as any).bloccomments.ShowComments(event);
        },
        handleScroll(event: any) {
            let self = this;
            if (window.innerWidth >= 576)
                return;
            let offset = $('.mc_piedpagebottom').offset();
            if (offset == undefined)
                return;
            let height: number | undefined = $(window).height();
            let scrolltop: number | undefined = $(window).scrollTop();
            if (height === undefined || scrolltop === undefined)
                return;
            if ((offset.top - height <= scrolltop) && this.last_pagenews <= this.numnews && !this.dcloadingnews) {
                this.dcloadingnews = true;
                var url = "/api/v1.0/news/NewsList?page=" + this.last_pagenews.toString() + "&pagesize=5&lancurrent=" + this.lancurrent + "&actucats=" + this.actucats;
                axios.get<NewsViewApiModel>(url).then(function (response: AxiosResponse<NewsViewApiModel>) {
                    if (response !== null && response.data !== null && response.data.newstab !== null) {
                        self.postnews = self.postnews.concat(response.data.newstab);
                        self.numnews = response.data.numtotalnews;
                        self.dcloadingnews = false;
                        self.last_pagenews++;
                    }

                });
            }
        },
          GetPhotoUrl(culture:string,idphoto:number, typephoto:number,mini:boolean,width:number, height:number):string {
            let url:string = "/" + culture + "/photo/Photo?idphoto=" + idphoto + "&typephoto=" + typephoto + "&mini=" + mini + "&width=" + width + "&height=" + height;
            return url;
        }
    },
    created() {
        window.addEventListener('scroll', this.handleScroll, { passive: true });
    },

    unmounted() {
        window.removeEventListener('scroll', this.handleScroll);
    },
    mounted() {
        this.idactu = gid;
        this.numcomments = gnumcomments;
        this.numcommentsinitial = gnumcommentsinitial;
        this.numnews = gnumtotalnews;
        this.lancurrent = glancurrent;
        this.actucats = gactucats;
        let self = this;
        fitvids();

        $(".newscont a img").each(function () {
            $(this).parent().attr("data-lightbox", "roadtrip");
        });
    }
});



export class ActuComponent {
    public Init(id: number, numcomments: number, numcommentsinitial: number, numtotalnews: number, lancurrent:string,actucats:string) {
        gid = id;
        gnumcomments = numcomments;
        gnumcommentsinitial = numcommentsinitial;
        gnumtotalnews = numtotalnews;
        glancurrent = lancurrent;
        gactucats = actucats;
        DCApp.mixins = [mixin];
        const app = Vue.createApp(DCApp);
        const pinia = createPinia();
        app.use(pinia);
        app.mount('#rootpage');
    }
}
(<any>(window)).ActuComponent = function () { return new ActuComponent(); };